export default __webpack_public_path__ + "static/media/result-close.1ea69ddd.svg";